export class PhasedRollOut {
    releaseNumber: string;
    releaseInfo: string;
    releaseDate: Date;
    capitalCost: number;
    omCost: number;
    comments: string;
}